/* eslint-disable no-console */
import {toast} from 'react-toastify';
import {Operation} from 'fast-json-patch';
import {IPresentation} from '../incase-domain/presentation';
import {ISlide, SlideWithoutElements} from '../incase-domain/slide';
import {httpDelete, httpGet, httpPatch, httpPost, httpPut} from './http.service';
import i18n from '../i18n';

export const saveSlideSwap = (presentationId: string, newIndex: number, oldIndex: number): Promise<void> => {
    return httpPut(`editor/slides/swap/${presentationId}`, {newIndex, oldIndex}).catch((error) => {
        console.log(error);
    });
};

export const addSlides = (presentationId: string, slidesToAdd: number, position: number, hidden: boolean): Promise<IPresentation> => {
    return httpGet(`editor/slides/add/${presentationId}/${slidesToAdd}/${position}/${hidden}`).catch((error) => {
        console.log(error);
    });
};

export const copyPresentationSlide = (slide: ISlide): Promise<ISlide> => {
    return httpPost(`editor/slides/copy`, slide).catch(() => {
        toast.error(i18n.t('toasts.slideDuplicateFail'));
    });
};

export const importPresentationSlide = (
    slideIds: string[],
    presentationId: string
): Promise<{slideIndexList: string[]; newSlides: ISlide[]}> => {
    return httpPost(`editor/slides/import/${presentationId}`, {slideIds}).catch((error) => {
        toast.error(i18n.t('toasts.importSlideFail'), error.response.status);
        return error.response.data;
    });
};

export const saveSlide = (slide: ISlide, isRejected?: boolean): Promise<ISlide> => {
    return httpPut(`editor/slides/save`, {slide, isRejected});
};

export const updateSlideWithoutElements = (slide: SlideWithoutElements): Promise<SlideWithoutElements> => {
    return httpPut(`editor/slides/updateSlideWithoutElements`, {slide});
};

export const deleteSlide = (slide: ISlide): Promise<{removed: boolean; removedId: string}> => {
    return httpDelete(`editor/slides/deleteSlide`, slide).catch((error) => {
        console.log(error);
    });
};

export const saveSlidePatch = (slideId: string, patch: Operation[]): Promise<void> => {
    return httpPatch(`editor/slides/savePatch`, {slideId, patch});
};
